<nav id="sidebarMenu" class="d-lg-block sidebarMenu" *ngIf="!commonService?.isHidden" @slidein>
  <app-menu-item *ngFor="let m of menu" [item]="m" [subMenuShouldOpenUp]="subMenuShouldOpenUp">
  </app-menu-item>
</nav>